import React, { useEffect, useState } from 'react';
import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Row,
  Select,
  Space,
  Switch,
  Tooltip
} from 'antd';
import { useFetchPageData, usePageData } from '../../../hooks/usePage';
import { IAppointment } from '../../../interfaces/patient';
import { IPageData } from '../../../interfaces/page';
import jwt_decode from 'jwt-decode';
import { QuestionCircleOutlined } from '@ant-design/icons';
import generalesProvider from '../../../services/generalesProvider';
import administracionProvider from '../../../services/administracionProvider';
import seguridadProvider from '../../../services/seguridadProvider';
import TablaUsuarios from './bandeja/TablaUsuarios';
import locale from 'antd/es/date-picker/locale/es_ES';

const moment = require('moment');
const { Option } = Select;
const pageData: IPageData = {
  fulFilled: true,
  breadcrumbs: [
    {
      title: 'Administración de Usuarios',
      route: 'administracion-usuarios'
    },
    {
      title: 'Usuarios'
    }
  ]
};

const key = 'regitrando';

const AdministracionUsuarios = () => {
  const token: any = jwt_decode(localStorage.getItem('token'));
  usePageData(pageData);
  const [cargandoRoles, setCargandoRoles] = useState(true);
  const [cargandoEmpresas, setCargandoEmpresas] = useState(true);
  const [cargandoJefaturas, setCargandoJefaturas] = useState(true);
  const [cargandoPuestos, setCargandoPuestos] = useState(true);
  const [cargandoCargos, setCargandoCargos] = useState(true);

  const [roles, setRoles] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [jefaturas, setJefaturas] = useState([]);
  const [puestos, setPuestos] = useState([]);
  const [cargos, setCargos] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [cargandoUsuarios, setCargandoUsuarios] = useState(false);

  const [form] = Form.useForm();

  const [usuario, setUsuario] = useState({});
  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24
      },
      sm: {
        span: 8
      }
    },
    wrapperCol: {
      xs: {
        span: 24
      },
      sm: {
        span: 16
      }
    }
  };
  const onFinish = async (val) => {
    if (form.getFieldValue('Id')) val.Id = form.getFieldValue('Id');
    val.FechaNacimiento = val.FechaNacimiento.format('DD/MM/YYYY');

    const response: any = await seguridadProvider.guardarUsuario(val);
    if (response.succeeded) {
      message.success({ content: response.message, key, duration: 5 });
    } else {
      message.error({ content: response.message, key, duration: 5 });
    }
    form.resetFields();
  };

  const validacionNombres = [
    {
      required: true,
      message: 'Ingrese nombres!'
    }
  ];
  const validacionApellidos = [
    {
      required: true,
      message: 'Ingrese apellidos!'
    }
  ];
  const validacionUsuario = [
    {
      required: true,
      message: 'Ingrese un usuario!',
      whitespace: true
    }
  ];
  const validacionContrasena = [
    {
      required: true,
      message: 'Ingrese una contraseña!'
    }
  ];
  const validacionContrasenaRepeat = [
    {
      required: true,
      message: 'Confirme su contraseña!'
    },
    ({ getFieldValue }) => ({
      validator(_, value) {
        if (!value || getFieldValue('Psw') === value) {
          return Promise.resolve();
        }

        return Promise.reject('No coinciden las contraseñas verifique!');
      }
    })
  ];
  const validacionDni = [
    {
      required: true,
      message: 'Ingrese un DNI!'
    }
  ];

  const acciones = [(val) => editarUsuario(val)];

  const editarUsuario = async (val) => {
    const response: any = await seguridadProvider.obtenerUsuario(val.id);
    form.setFieldsValue({
      Id: response.id,
      Usr: response.usr,
      Apellidos: response.apellidos,
      Nombres: response.nombres,
      Correo: response.correo,
      Cip: response.cip,
      Dni: response.dni,
      FechaNacimiento: moment(response.fechaNacimiento),
      RolId: response.rolId,
      EmpresaId: response.empresaId,
      PuestoId: response.puestoId,
      CargoId: response.cargoId,
      JefaturaId: response.jefaturaId,
      Telefono: response.telefono,
      RestriccionAcceso: response.restriccionAcceso,
      PswNuevo: ''
    });
    form.getFieldValue('Id') ? setIsEdit(true) : setIsEdit(false);
  };

  const leyendaUsuario = () => (
    <>
      <span>
        Usuario&nbsp;
        <Tooltip title='El usuario debe de ser unico en la aplicación?'>
          <QuestionCircleOutlined />
        </Tooltip>
      </span>
    </>
  );

  const obtenerListaValor = async () => {
    const empresas: any = await administracionProvider.obtenerEmpresas();
    setCargandoEmpresas(false);
    const roles: any = await seguridadProvider.obtenerRoles();
    setCargandoRoles(false);
    const jefaturas: any = await generalesProvider.obtenerListaValor(6);
    setCargandoJefaturas(false);
    const puestos: any = await generalesProvider.obtenerListaValor(7);
    setCargandoPuestos(false);
    const cargos: any = await generalesProvider.obtenerListaValor(8);
    setCargandoCargos(false);
    setJefaturas(jefaturas);
    setPuestos(puestos);
    setCargos(cargos);
    setEmpresas(empresas);
    setRoles(roles);
  };

  useEffect(() => {
    obtenerListaValor();
  }, []);

  return (
    <>
      <Card title={'Administración de usuarios'}>
        <div className='row'>
          <div className='col-md-6'>
            <Form
              {...formItemLayout}
              form={form}
              name='register'
              onFinish={onFinish}
              initialValues={usuario}
              scrollToFirstError
            >
              <Form.Item name='Usr' label={leyendaUsuario()} rules={validacionUsuario}>
                <Input />
              </Form.Item>
              {!isEdit && (
                <>
                  <Form.Item name='Psw' label='Contraseña' rules={validacionContrasena} hasFeedback>
                    <Input.Password />
                  </Form.Item>
                  <Form.Item
                    name='PswNuevo'
                    label='Repita Contraseña'
                    dependencies={['Psw']}
                    hasFeedback
                    rules={validacionContrasenaRepeat}
                  >
                    <Input.Password />
                  </Form.Item>
                </>
              )}
              <Form.Item name='Apellidos' label='Apellidos' rules={validacionApellidos}>
                <Input />
              </Form.Item>
              <Form.Item name='Nombres' label='Nombres' rules={validacionNombres}>
                <Input />
              </Form.Item>
              <Form.Item
                name='Correo'
                label='Correo'
                rules={[
                  {
                    type: 'email',
                    message: 'El correo no es valido!'
                  },
                  {
                    required: true,
                    message: 'Ingrese correo!'
                  }
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item name='Cip' label='Cip'>
                <Input />
              </Form.Item>
              <Form.Item name='Dni' label='DNI' rules={validacionDni}>
                <Input />
              </Form.Item>
              <Form.Item
                name='FechaNacimiento'
                label='F. nacimiento'
                rules={[{ required: true, message: 'Fecha de nacimiento es requerido' }]}
              >
                <DatePicker
                  placeholder={'dd/mm/yyyy'}
                  style={{ width: '100%' }}
                  locale={locale}
                  format={'DD/MM/YYYY'}
                />
              </Form.Item>
              <Form.Item
                name='RolId'
                label='Rol'
                rules={[{ required: true, message: 'Seleccione un rol!' }]}
              >
                <Select loading={cargandoRoles}>
                  {roles.map((p, index) => {
                    return (
                      <Option key={index} value={p.id}>
                        {p.nombre}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
              <Form.Item
                name='EmpresaId'
                label='Empresa'
                rules={[{ required: true, message: 'Empresa es requerida' }]}
              >
                <Select loading={cargandoEmpresas}>
                  {empresas.map((p, index) => {
                    return (
                      <Option key={index} value={p.id}>
                        {p.nombre}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
              <Form.Item
                name='PuestoId'
                label='Puesto'
                rules={[{ required: true, message: 'Puesto es requerido' }]}
              >
                <Select loading={cargandoPuestos}>
                  {puestos.map((p, index) => {
                    return (
                      <Option key={index} value={p.id}>
                        {p.nombre}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
              <Form.Item
                name='CargoId'
                label='Cargo'
                rules={[{ required: true, message: 'Cargo es requerido' }]}
              >
                <Select loading={cargandoCargos}>
                  {cargos.map((p, index) => {
                    return (
                      <Option key={index} value={p.id}>
                        {p.nombre}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
              <Form.Item name='JefaturaId' label='Jefatura'>
                <Select loading={cargandoJefaturas}>
                  {jefaturas.map((p, index) => {
                    return (
                      <Option key={index} value={p.id}>
                        {p.nombre}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
              <Form.Item name='Telefono' label='Telefono'>
                <Input />
              </Form.Item>
              <Form.Item
                name={'RestriccionAcceso'}
                label={'Restricción de acceso'}
                valuePropName='checked'
              >
                <Checkbox />
              </Form.Item>
              <Row justify={'center'}>
                <Col>
                  <Form.Item>
                    <Space size={'middle'}>
                      <Button type='primary' htmlType='submit'>
                        {!isEdit ? 'Registrar' : 'Actualizar'}
                      </Button>
                      <Button type='default' onClick={() => form.resetFields()}>
                        Limpiar
                      </Button>
                    </Space>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
          <div className='col-md-6'>
            <TablaUsuarios {...acciones} />
          </div>
        </div>
      </Card>
    </>
  );
};

export default AdministracionUsuarios;
